<forge-text-field [invalid]="isInvalid" data-lpignore="true" [attr.shape]="forCellEdit ? 'squared' : null"
  [ngClass]="{'dense-input': dense || compact, 'cell-edit': forCellEdit}" [density]="Density"
  [required]="isRequired" [attr.label-position]="LabelPosition">
  <input #input type="text" [disabled]="isViewOnly" [name]="Name" id="txt_{{Name}}" [(ngModel)]="valueModel"
    (input)="onInputChange()" (change)="onChange()" [required]="isRequired" [maxlength]="MaxLength"
    [minlength]="MinLength" focusOnLoad [propertyMetadata]="propertyMetadata" [forCellEdit]="forCellEdit" data-lpignore="true"
    (keydown)="enforceFormat($event)" (keyup)="formatToPhone($event)" attr.telemetry="Edit-{{Label}}"
    autocomplete="off" [pattern]="Regex">
    <label for="txt_{{Name}}">{{Label}}</label>
    @if (hint && !dense && !compact && !isInvalid) {
      <span slot="support-text">{{hint}}</span>
    }
    @if (isInvalid && !dense && !compact) {
      <span slot="support-text" class="error-red">{{error}}</span>
    }
    @if (showSpinner) {
      <forge-circular-progress class="metadata-input--spinner" slot="end">
      </forge-circular-progress>
    }
  </forge-text-field>
